import * as Styled from './styles';
export const Button = ({ children, rounded = true }) => {
    return (
        <Styled.Container rounded>
            {children}
        </Styled.Container>
    );
};